import React, { useState, useEffect } from 'react';

import './ProductsComp.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle';

import HeaderComp from '../../common/header/HeaderComp';
import PageBannerComp from '../../common/page-banner/PageBannerComp';
import DefaultSectionComp from '../../common/default-section-components/DefaultSectionComp';
import FooterComp from '../../common/footer/FooterComp';
import ProductsListComp from './ProductsListComp';
import ProductDetailsComp from './ProductDetailsComp';
import PageNotFoundComp from '../../common/404/PageNotFoundComp';
import { useParams } from "react-router-dom";

import productsJson from '../../../../assets/data/products.json';
import { CDN_URL } from '../../../../config/config';

const ProductsComp = (props) => {
    
    const { paramPId } = useParams();
    const [pId, setPId] = useState('');

    useEffect(() => { if(typeof paramPId != 'undefined'){ setPId(paramPId); }else{ setPId(''); } }, [paramPId]);

    let pageStatus = true;
    let pageContent = <PageNotFoundComp title={"Page not Found!"} desc={"The page you are trying to access is not found, please try again."} link={"http://localhost:3000"} linkTitle={"Go to Home"} />;
    let bannerDetails = {
        "title": "Our Products",
        "tagline": "Brilliant, Modern and Utilitarian",
        "desc": "Fibre cement boards are being used in some of the most iconic buildings of our time because they save time and money. They are safer and are aesthetically more beautiful.",
        "image": "visaka/vnext/website/assets/images/bg.webp"
    };

    if(pId !== ''){
        let pIdStatus = false;
        let pIdDetails = false;
        productsJson.map((p) => { if (p.key === pId) { pIdStatus = true; pIdDetails = p; } return true; });
        if(pIdStatus === true){
            pageContent = <ProductDetailsComp pDetails={pIdDetails} />;
            bannerDetails.title = pIdDetails.title;
            bannerDetails.tagline = pIdDetails.tagline;
            bannerDetails.desc = pIdDetails.desc;
            bannerDetails.image = pIdDetails.background_image;
        }else{ pageStatus = false; }
    }else{ pageContent = <ProductsListComp productsJson={productsJson} />; }

    return (<>
        <HeaderComp />
        {pageStatus && <PageBannerComp className={'page-banner-comp'} bType="banner" bDetails={bannerDetails} />}
        {pageContent}
        {pageStatus && <DefaultSectionComp className="section bg-img home-section-join-hands" customInlineStyles={{backgroundImage:`url(${CDN_URL}visaka/vnext/website/assets/images/bg2.webp)`}}>
            <div className='container pb-5 mb-5'>
                <div className="text-center home-section-join-hands-content pb-5 mb-5">
                    <h2 className='title'>JOIN HANDS IN BUILDING<br />AN <b className='color-green'>ECO-FRIENDLY</b> FUTURE</h2>
                    <p className='desc mb-5 pb-5'><q>SMALL ACTS, WHEN MULTIPLIED BY MILLIONS OF PEOPLE, CAN TRANSFORM THE WORLD.</q></p>
                </div>
            </div>
        </DefaultSectionComp> }
        <FooterComp />
    </>);
}
export default ProductsComp;
